import React from "react";
import * as echarts from "echarts";

const EChart = ({
  option,
  loading = false,
  onClick = null,
  className = "",
  style = null,
}) => {
  const hostRef = React.useRef(null);
  const chartRef = React.useRef(null);

  React.useEffect(() => {
    if (!hostRef.current) return undefined;

    const chart = echarts.init(hostRef.current, null, { renderer: "canvas" });
    chartRef.current = chart;

    const resize = () => chart.resize();
    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(resize)
      : null;

    if (observer) observer.observe(hostRef.current);
    else window.addEventListener("resize", resize);

    return () => {
      if (observer) observer.disconnect();
      else window.removeEventListener("resize", resize);
      chart.dispose();
      chartRef.current = null;
    };
  }, []);

  React.useEffect(() => {
    const chart = chartRef.current;
    if (!chart || !option) return;
    chart.setOption(option, { notMerge: true, lazyUpdate: false });
  }, [option]);

  React.useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return undefined;

    chart.off("click");
    if (onClick) chart.on("click", onClick);

    return () => chart.off("click");
  }, [onClick]);

  React.useEffect(() => {
    const chart = chartRef.current;
    if (!chart) return;

    if (loading) {
      chart.showLoading("default", {
        text: "",
        maskColor: "rgba(255, 255, 255, 0.72)",
      });
    } else {
      chart.hideLoading();
    }
  }, [loading]);

  return <div ref={hostRef} className={className} style={style} />;
};

export default EChart;
